import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { CONTACT_EMAIL, CONTACT_MAILTO } from "../../lib/contact";

type Props = {
  children: ReactNode;
};

export function PublicChrome({ children }: Props) {
  return (
    <div className="landing min-h-dvh bg-canvas text-ink">
      <header className="sticky top-0 z-20 border-b border-line bg-white/95 backdrop-blur-sm">
        <nav
          className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-6"
          aria-label="Główna nawigacja"
        >
          <Link to="/welcome" className="flex min-h-12 items-center gap-2.5" aria-label="AgroHodowca">
            <img
              src="/static/img/logo.png"
              width={44}
              height={44}
              alt=""
              className="h-11 w-11 rounded-xl object-cover"
            />
            <span className="text-lg font-bold tracking-tight sm:text-xl">
              Agro
              <span className="border-b-[3px] border-gold pb-0.5">Hodowca</span>
            </span>
          </Link>
          <Link
            to="/login"
            className="inline-flex min-h-12 touch-manipulation items-center justify-center rounded-xl bg-brand px-4 text-base font-semibold text-white shadow-sm hover:bg-brand-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand sm:px-5"
            data-testid="landing-nav-cta"
          >
            Zaloguj się
          </Link>
        </nav>
      </header>

      {children}

      <footer className="border-t border-line bg-white">
        <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <div>
            <p className="text-base font-bold">AgroHodowca</p>
            <p className="mt-1 max-w-lg text-sm leading-relaxed text-muted">
              Rejestr stada, stanówka, wykoty, zasoby, kontrole, finanse i IRZplus — na telefonie i
              komputerze.
            </p>
          </div>
          <div className="flex flex-col gap-1 text-sm sm:items-end">
            <a
              href={CONTACT_MAILTO}
              className="min-h-11 font-semibold text-brand hover:underline"
              data-testid="landing-footer-contact"
            >
              {CONTACT_EMAIL}
            </a>
            <Link to="/privacy" className="min-h-11 font-semibold text-brand hover:underline">
              Polityka prywatności
            </Link>
            <Link to="/terms" className="min-h-11 font-semibold text-brand hover:underline">
              Regulamin
            </Link>
            <p className="text-muted">© {new Date().getFullYear()} AgroHodowca</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
